import React from 'react';
import { Box, Typography, Breadcrumbs, Link, Chip } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';

export default function PageHeader({ title, subtitle, breadcrumbs = [], action, chip }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbs.length > 0 && (
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 1 }}>
          {breadcrumbs.map((b, i) =>
            i < breadcrumbs.length - 1 ? (
              <Link
                key={b.label}
                underline="hover"
                color="text.secondary"
                sx={{ cursor: 'pointer', fontSize: 13 }}
                onClick={() => navigate(b.path)}
              >
                {b.label}
              </Link>
            ) : (
              <Typography key={b.label} color="text.primary" sx={{ fontSize: 13 }}>
                {b.label}
              </Typography>
            )
          )}
        </Breadcrumbs>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h5">{title}</Typography>
            {chip && <Chip label={chip.label} color={chip.color} size="small" />}
          </Box>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box>{action}</Box>}
      </Box>
    </Box>
  );
}
